var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowrightstop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32715 12.4785C4.32715 12.8213 4.56445 13.0674 4.91602 13.0674H14.7773L16.6758 13.0146L14.1094 15.4141L11.5342 17.9893C11.4199 18.1035 11.3584 18.2705 11.3584 18.4375C11.3584 18.7803 11.6133 19.0264 11.9473 19.0264C12.123 19.0264 12.2725 18.9473 12.4219 18.7979L18.293 12.918C18.3896 12.8389 18.4512 12.7334 18.4775 12.6279V18.5166C18.4775 18.8594 18.7236 19.0967 19.0752 19.0967C19.4268 19.0967 19.6729 18.8594 19.6729 18.5166V6.44043C19.6729 6.08887 19.4268 5.85156 19.0752 5.85156C18.7236 5.85156 18.4775 6.08887 18.4775 6.44043V12.3203C18.4512 12.2148 18.3896 12.1094 18.293 12.0303L12.4219 6.1416C12.2725 6.00098 12.123 5.92188 11.9473 5.92188C11.6133 5.92188 11.3584 6.16797 11.3584 6.50195C11.3584 6.66895 11.4199 6.83594 11.5342 6.9502L14.1094 9.53418L16.667 11.9336L14.7773 11.8809H4.91602C4.56445 11.8809 4.32715 12.127 4.32715 12.4785Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowrightstop);
export default __webpack_public_path__ + "static/media/Arrow right stop.8101a327745a85a82f92009ea787371a.svg";
export { ForwardRef as ReactComponent };